import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { Image } from "expo-image";
import Icons from "@/assets/icons";
import Images from "@/assets/images";

const CheckItem = ({ text }: { text: string }) => (
  <View style={styles.checkItem}>
    <Icons.Check width={24} height={24} />
    <Text style={styles.checkText}>{text}</Text>
  </View>
);

const ClaimCard = ({
  icon,
  iconBgColor,
  title,
  amount,
  amountColor,
}: {
  icon: React.ReactNode;
  iconBgColor: string;
  title: string;
  amount: string;
  amountColor?: string;
}) => (
  <View style={styles.claimCard}>
    <View style={[styles.cardIcon, { backgroundColor: iconBgColor }]}>
      {icon}
    </View>
    <View style={styles.cardContent}>
      <Text style={styles.cardTitle}>{title}</Text>
      <Text style={[styles.cardAmount, amountColor && { color: amountColor }]}>{amount}</Text>
    </View>
    <View style={styles.noProofBadge}>
      <Icons.Check width={12} height={12} />
      <Text style={styles.noProofText}>No proof</Text>
    </View>
  </View>
);

export default function WelcomeSlideNew3() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{"Get money you didn't know you had"}</Text>

      <View style={styles.cardsContainer}>
        <View style={styles.backCard}>
          <ClaimCard
            icon={<Image source={Images.facebookIcon} style={styles.facebookIcon} />}
            iconBgColor="#1877F1"
            title="McDonald's"
            amount="Up to $15"
            amountColor="rgba(22, 29, 20, 0.70)"
          />
        </View>
        <ClaimCard
          icon={<Image source={Images.youtubeIcon} style={styles.youtubeIcon} />}
          iconBgColor="#F3F3F3"
          title="YouTube Privacy"
          amount="Up to $60"
        />

        <View style={styles.claimButtonContainer}>
          <View style={styles.scribbleIcon}>
            <Icons.Scribble width={23} height={23} />
          </View>
          <View style={styles.claimButton}>
            <Text style={styles.claimButtonText}>Claim</Text>
          </View>
          <View style={styles.cursorIcon}>
            <Icons.Cursor width={24} height={24} />
          </View>
        </View>
      </View>

      <View style={styles.checkList}>
        <CheckItem text="Claim class action settlements" />
        <CheckItem text="Recover unclaimed property" />
        <CheckItem text="Get refunds from brands & airlines" />
        <CheckItem text="Cancel subscriptions" />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 36,
    color: "#161D14",
    lineHeight: 39,
    letterSpacing: -0.72,
    marginBottom: 24,
    marginTop: 30,
  },
  cardsContainer: {
    position: "relative",
    marginBottom: 40,
    marginTop: 40,
    height: 180,
  },
  claimCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#EBEBEB",
    padding: 12,
    flexDirection: "row",
    alignItems: "center",
    shadowColor: "#CCCCCC",
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: 0.5,
    shadowRadius: 3,
    elevation: 10,
  },
  backCard: {
    position: "absolute",
    bottom: 40,
    left: 12,
    right: 12,
    transform: [{ scale: 0.92 }],
    zIndex: 0,
  },
  cardIcon: {
    width: 72,
    height: 72,
    borderRadius: 14,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 16,
  },
  facebookIcon: {
    width: "100%",
    height: "100%",
  },
  youtubeIcon: {
    width: "100%",
    height: "100%",
  },
  cardContent: {
    flex: 1,
  },
  cardTitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 14,
    color: "#161D14",
    lineHeight: 21,
    marginBottom: 4,
  },
  cardAmount: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 20,
    color: "#161D14",
    lineHeight: 20,
  },
  noProofBadge: {
    backgroundColor: "rgba(15, 145, 41, 0.1)",
    borderRadius: 18,
    paddingHorizontal: 9,
    paddingVertical: 5,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  noProofText: {
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 11.5,
    color: "#0F9129",
    letterSpacing: -0.23,
  },
  claimButtonContainer: {
    position: "absolute",
    right: 20,
    bottom: 50,
  },
  scribbleIcon: {
    position: "absolute",
    top: -30,
    left: 90,
  },
  claimButton: {
    backgroundColor: "#0F9129",
    borderRadius: 12,
    paddingHorizontal: 45,
    paddingVertical: 10,
    shadowColor: "#CCCCCC",
    shadowOffset: { width: 2, height: 9 },
    shadowOpacity: 0.5,
    shadowRadius: 3,
    elevation: 10,
    transform: [{ rotate: "-6deg" }],
  },
  claimButtonText: {
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 15,
    color: "#FFFFFF",
  },
  cursorIcon: {
    position: "absolute",
    right: 5,
    bottom: -3,
  },
  checkList: {
    gap: 12,
  },
  checkItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  checkText: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    color: "#000000",
    opacity: 0.7,
    lineHeight: 23,
    flex: 1,
  },
});
